<template>
    <v-col
        cols="12"
        class="d-flex pt-0 pb-2"
    >
        <div class="flex-nowrap d-flex flex-grow-1" style="min-width: 0">
            <div class="flex-shrink-1">
                <div style="position: relative; height: 100%" class="mr-3">
                    <div
                        v-if="!isLastOfList"
                        style="border: 1px solid var(--v-g3-base) !important; position: absolute; left: 50%; top: 0; transform: translate(-50%, 0); height: calc(100% + 8px)"
                    />
                    <div
                        style="border-radius: 100%; border: 1px solid var(--v-g3-base) !important; position:relative; width: 36px; height: 36px"
                        :class="logoBackgroundColor"
                        class="d-flex justify-center align-center"
                    >
                        <icon
                            icon="Mail"
                            size="22"
                            :color="['failed', 'warning'].includes(emailLog.status) ? 'white' : 'g5'"
                        />
                        <div
                            v-if="COMMUNICATION_TASK_LOG_TYPES.includes(emailLog.type)"
                            style="border: 1px solid var(--v-g3-base) !important; position: absolute; right: -6px; bottom: -6px"
                            class="rounded-circle white"
                        >
                            <div
                                style="transform: rotate(180deg); padding: 2px"
                                class="d-flex"
                            >
                                <icon
                                    color="main"
                                    size="16"
                                    icon="Reply"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="flex-grow-1"
                style="min-width: 0"
                :class="COMMUNICATION_TASK_LOG_TYPES.includes(emailLog.type) ? 'pl-3' : ''"
            >
                <div
                    class="px-4 pt-3 pb-5 cursor-pointer elevation-4 rounded-lg"
                    :class="contentBackgroundColor"
                    @click="$emit('select-email-log', emailLog.id)"
                >
                    <div class="d-flex">
                        <AccountAvatar
                            size="24"
                            text-color="neutral_n300"
                            text-class="font-weight-medium caption"
                            :color="emailLog.sender.avatar ? 'white' : 'neutral_n40'"
                            :initials="emailLog.sender.initials"
                            :image-path="emailLog.sender.avatar"
                        />
                        <div style="max-width: calc(100% - 32px); width: 100%;" class="ml-2">
                            <div
                                style="min-height: 26px"
                                class="d-flex flex-nowrap align-center mb-2"
                            >
                                <div class="d-flex flex-column">
                                    <div
                                        v-if="['failed', 'warning'].includes(emailLog.status)"
                                        class="body-2 font-weight-medium error--text mr-1 d-flex align-center"
                                    >
                                        <icon
                                            size="18"
                                            color="error"
                                            icon="AlertTriangle"
                                        />
                                        <div class="ml-2">
                                            <template v-if="emailLog.status === 'failed'">
                                                {{ $t('Email not delivered') }}
                                            </template>
                                            <template v-else-if="emailLog.status === 'warning'">
                                                {{ $t('Sent, but fallback to Uku email') }}
                                            </template>
                                            <template v-else>
                                                {{ $t('Unknown') }}
                                            </template>
                                        </div>
                                    </div>
                                    <div class="body-2 g5--text">
                                        <template v-if="emailLog.type === TASK_LOG_TYPE.TASK_MESSAGE_FROM_PROJECT_EMAIL">
                                            <span class="font-weight-medium">
                                                {{ emailLog.sender.from_name ? emailLog.sender.from_name : emailLog.from_name }}
                                            </span>
                                            {{ $t("replied to project email") }}
                                        </template>
                                        <template v-else-if="emailLog.type === TASK_LOG_TYPE.TASK_MESSAGE_FROM_CLIENT_EMAIL">
                                            <span class="font-weight-medium">
                                                {{ emailLog.sender.from_name ? emailLog.sender.from_name : emailLog.from_name }}
                                            </span>
                                            {{ $t("replied to client email") }}
                                        </template>
                                        <template v-else-if="emailLog.type === TASK_LOG_TYPE.TASK_INCOMING_EMAIL">
                                            <span class="font-weight-medium">
                                                {{ emailLog.sender.from_name ? emailLog.sender.from_name : emailLog.from_name }}
                                            </span>
                                            {{ $t("replied to client portal email") }}
                                        </template>
                                        <template v-else-if="emailLog.type === TASK_LOG_TYPE.TASK_MESSAGE_FROM_EMAIL">
                                            <span class="font-weight-medium">
                                                {{ emailLog.sender.from_name ? emailLog.sender.from_name : emailLog.from_name }}
                                            </span>
                                            {{ $t("replied to task email") }}
                                        </template>
                                        <template v-else>
                                            <span class="font-weight-medium">
                                                {{ emailLog.sender.from_name ? emailLog.sender.from_name : emailLog.from_name }}
                                            </span>
                                            {{ $t('To') }}
                                            <span class="font-weight-medium">
                                                {{ emailLog.to_name }}
                                            </span>
                                        </template>

                                    </div>
                                </div>
                                <div class="ml-auto d-flex align-center align-self-start mt-1">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <div
                                                style="white-space: nowrap"
                                                class="ml-auto caption g5--text align-self-start"
                                                v-on="on"
                                            >
                                                {{ formatDateTimeOrTime(emailLog.sent_at) }}
                                            </div>
                                        </template>
                                        {{ formatDateTime(emailLog.sent_at) }}
                                    </v-tooltip>
                                    <v-tooltip v-if="emailLog.project_id && showProjectType" bottom>
                                        <template #activator="{ on }">
                                            <div
                                                class="d-flex ml-1"
                                                v-on="on"
                                            >
                                                <router-link
                                                    :to="{ name: 'project_view', params: { id: emailLog.project_id } }"
                                                    class="d-inline-flex"
                                                >
                                                    <icon icon="ClipboardList" size="16" :color="emailLog.project_color" />
                                                </router-link>
                                            </div>
                                        </template>
                                        {{ emailLog.project_name }}
                                    </v-tooltip>
                                </div>
                                <v-tooltip
                                    v-if="emailLog.client && emailLog.task && emailLog.task_id"
                                    right
                                >
                                    <template #activator="{ on }">
                                        <div v-on="on" class="ml-1" @click.stop="openTask(emailLog.task_id)">
                                            <ClientAvatar
                                                :initials="emailLog.client.client_initials"
                                                :color="emailLog.client.color"
                                                :size="24"
                                            />
                                        </div>
                                    </template>
                                    {{ emailLog.task.title }}
                                </v-tooltip>

                                <!--<icon-button
                                    :color="emailLog.is_pinned ? 'secondary' : 'n3'"
                                    @click="onPinChange(emailLog, $event)"
                                >
                                    mdi-pin
                                </icon-button>-->
                            </div>
                            <div class="subtitle-2">
                                {{ emailLog.subject }}
                            </div>
                            <div
                                style="white-space: nowrap; text-overflow: ellipsis"
                                class="body-2 overflow-hidden"
                            >
                                {{ excerpt }}
                            </div>
                            <div>
                                <icon v-if="emailLog.attachments" color="n3" size="20" icon="Paperclip" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-col>
</template>

<script>
import { computed } from "@vue/composition-api";
import { formatDateTime, formatDateTimeOrTime } from "@/plugins/formatting"
import AccountAvatar from "@/components/AccountAvatar.vue";
import {QUOTE_HEADERS_REGEX, QUOTE_REGEX, SIGNATURE_REGEX, TASK_LOG_TYPE, COMMUNICATION_TASK_LOG_TYPES} from "@/helpers/constants";
import {$t} from "@/i18n";
import ClientAvatar from "@/components/ClientAvatar.vue";
import TaskModule from "@/store/modules/task"
import Parser from "node-email-reply-parser/lib/Parser"

export default {
    name: "CommunicationHistory",
    methods: {$t},
    computed: {
        TASK_LOG_TYPE() {
            return TASK_LOG_TYPE
        }
    },
    components: {ClientAvatar, AccountAvatar},
    props: {
        emailLog: {
            type: Object,
            required: true
        },
        isLastOfList: {
            type: Boolean,
            default: false
        },
        showProjectType: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const { openTask } = TaskModule()
        const onPinChange = (emailLog, event) => {
            event.stopPropagation()

            ctx.emit('update-pin', {
                emailLogId: emailLog.id,
                isPinned: !emailLog.is_pinned
            })
        }

        const logoBackgroundColor = computed(() => {
            if (['failed', 'warning'].includes(props.emailLog.status)) {
                return 'error'
            }

            return 'white'
        })

        const contentBackgroundColor = computed(() => {
            if (['failed'].includes(props.emailLog.status)) {
                return 'error lighten-2'
            }

            return 'white'
        })

        const excerpt = computed(() => {
            if (props.emailLog.type === TASK_LOG_TYPE.TASK_INCOMING_EMAIL) {
                const parser = new Parser(SIGNATURE_REGEX, QUOTE_REGEX, QUOTE_HEADERS_REGEX)
                const parsed = parser.parse(props.emailLog.message)
                return parsed.getVisibleText()
            } else {
                return props.emailLog.excerpt
            }
        })

        return {
            onPinChange,
            formatDateTime,
            formatDateTimeOrTime,
            logoBackgroundColor,
            contentBackgroundColor,
            openTask,
            excerpt,
            COMMUNICATION_TASK_LOG_TYPES
        }
    }
};
</script>
